export interface FilterDrawerState {
  showSaveFilterModal: boolean;
  showDateAccordion: boolean;
  saveFilterType: string;
}

export const initialFilterDrawerState: FilterDrawerState = {
  showSaveFilterModal: false,
  showDateAccordion: false,
  saveFilterType: '',
};

type FilterDrawerAction =
  | { type: 'TOGGLE_SAVE_FILTER_MODAL' }
  | { type: 'TOGGLE_DATE_ACCORDION'; payload: boolean }
  | { type: 'SET_SAVE_FILTER_TYPE'; payload: string };

export const filterDrawerReducer = (
  state: FilterDrawerState = initialFilterDrawerState,
  action: FilterDrawerAction
): FilterDrawerState => {
  switch (action.type) {
    case 'TOGGLE_SAVE_FILTER_MODAL':
      return {
        ...state,
        showSaveFilterModal: !state.showSaveFilterModal,
      };
    case 'TOGGLE_DATE_ACCORDION':
      return {
        ...state,
        showDateAccordion: action.payload,
      };
    case 'SET_SAVE_FILTER_TYPE':
      return {
        ...state,
        saveFilterType: action.payload,
      };
    default:
      return state;
  }
};
